export const networkMethods = {
  post: 'POST',
  get: 'GET',
  delete: 'DELETE',
  put: 'PUT'
};

export const REQUEST_PAGINATION_MAX_LIMIT = Number.MAX_SAFE_INTEGER;
